export interface GetEquipmentCatalogPayload {
    SortDto?: { Field: string; Order: string };
    Filters?: any[];
    GlobalFilter?: string | null;
    PageNumber?: number;
    PageSize?: number;
    CatalogType?: string;
};

export interface uploadEquipmentPayload {
    File?: any;
    CatalogType?: string;
};

export enum CatalogType {
    DRCables = 0,
    DRGasHandlers = 1,
    DRGasSeparators = 2,
    DRMotorLeads = 3,
    DRMotorSensors = 4,
    DRMotors = 5,
    DRProtectors = 6,
    DRPumps = 7,
    DRSwitchBoard = 8,
    DRVSD = 9,
    SRAccAboveESP = 10,
    SRAccBelowESP = 11,
    SRBOH = 12,
    SRCables = 13,
    SRGasHandlers = 14,
    SRGasSeparators = 15,
    SRMLE = 16,
    SRMotors = 17,
    SRProtectors = 18,
    SRPumps = 19,
    SRTransformers = 20,
    SRVSDs = 21,
    HarmonicFilters = 22,
};

export interface SRCables {
    armorMaterial: string;
    awG_id: number;
    barrier: string;
    dimensions: string;
    id: string;
    insulation: string;
    nominalWeight: number;
    pN_Description: string;
    pn: number;
    profile: string;
    standardization: boolean;
    tempRating_C: number;
    totalLength: number;
    voltRating_KV: number;
};

export interface SRGasHandlers {
    gas_Handling: string;
    id: string;
    length: number;
    noStages: number;
    od: number;
    pn: number;
    pumpName: string;
    series: string;
    shaftType: string;
    standardization: boolean;
    weight: number;
};

export interface SrGasSeparators {
    id: string;
    length: number;
    od: number;
    pN_Description: string;
    pn: number;
    position: string;
    series: string;
    seriesType: string;
    standardization: boolean;
    status: string;
    weight: number;
};

export interface SrMotors {
    baseConnection: string;
    configuration: string;
    current: string;
    id: string;
    length: number;
    max_BHT: number;
    name: string;
    od: number;
    pN_Description: string;
    pn: number;
    series: string;
    size: number;
    status: string;
    std: boolean;
    tempUnit: string;
    voltage: number;
    weight: number;
};

export interface SrProtectors {
    bearingType: string;
    configuration: string;
    id: string;
    length: number;
    model: string;
    name: string;
    od: number;
    pN_Description: string;
    pn: number;
    series: string;
    shaftMaterial: string;
    standardization: boolean;
    weight: number;
};

export interface SrMLE {
    dimension: string;
    id: string;
    length: number;
    mle: string;
    pn: number;
    series: string;
    standardization: boolean;
    weight: number;
    wire_Gauge: number;
};

export interface SrAccBelowESP {
    accBelowESP: string;
    diameter: number;
    id: string;
    length: number;
    casing_Diam__In: number;
    weight: number;
    pn: number;
};

export interface SrAccAboveESP {
    accAboveESP: string;
    diameter: number;
    id: string;
    length: number;
    masked_Diam: number;
    weight: number;
};

export interface SrBOH {
    boh: string;
    id: string;
    length: number;
    od: number;
    pn: number;
    series: string;
    tubing: string;
    tubingOD: number;
    weight: number;
};

export interface SrPumps {
    id: string;
    length: number;
    noStgs: number;
    od: number;
    pN_Description: string;
    partNumber: number;
    pump: string;
    series: string;
    shaftType: string;
    standardization: boolean;
    weight: number;
};

export interface SrTransformers {
    id: string;
    kva: number;
    pn: number;
    sec: number;
    sec_Y: number;
    standardization: boolean;
    transformers: string;
};

export interface SrVSDs {
    aalS_Description: string;
    id: string;
    oracle_Item_Number: number;
    power: number;
    status: string;
    std: boolean;
    uom: string;
};

export interface SrSensors {
    diameter: number;
    equipmentStatus: string;
    international: boolean;
    length: number;
    name: string;
    permian: boolean;
    pn: number;
    sensorId: string;
    series: string;
    weight: number;
};

export interface HarmonicFilters {
    id: string;
    filterType: string;
    harmonicFilters: string;
    harmPN: number;
    lowLimitAmps: number;
    highLimitAmps: number;
    ampsFilter: number;
    status: string;
    createdOn: string;
    createdBy: number;
    modifiedOn: string;
    modifiedBy: number;
    createdByName: string;
    modifiedByName: string;
};
